<template>
    <!-- 时间选择 -->
    <div @click="setEditIndex(index)">
        <el-row :gutter="10" style="margin-left:5px">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{number}}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
                <el-input placeholder="请输入题目内容" @focus="showAdvance" @blur="updateQuestion()" v-model="question.questionsName"
                          autosize></el-input>
            </el-col>
            <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
                <i class="el-icon-delete delete" v-if="index==editIndex" @click="questiondel(question.id)"></i>
                <el-badge 
          v-if="question.displayscriptcount || question.jumpscriptcount" 
          :value="question.displayscriptcount + question.jumpscriptcount" 
          class="item">
          <i
            class="el-icon-share"
            @click="()=>$emit('jumpshow',question.id)"
          ></i>
        </el-badge>
        <i class="el-icon-rank item drag-handle"></i>
            </el-col>
        </el-row>
        <!-- v-for="(childItem,childindex) in question.optionList" -->
        
        <el-row :gutter="10" style="margin-top: 12px !important;" 
                :key="index+'_'+childindex" v-for="(childItem,childindex) in question.optionList">
            <div @click="setEditOptionIndex(childindex)">
                <!-- <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                    <span style="color: #FFF;">占</span>
                </el-col> -->
                
                
            </div>
        </el-row>
        <div class="questiontime">
                    <!-- <el-select v-model="value1" placeholder="小时">
                        <el-option
                            v-for="item in options1"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select> -->
                    <fake-input placeholder="小时" />
                    :
                     <fake-input placeholder="分钟" />
                    <!-- <el-select v-model="value2" placeholder="分钟">
                        <el-option
                            v-for="item in options2"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                        </el-option>
                    </el-select> -->
                </div>
        <el-row :gutter="10" style="margin-top: 12px !important;" v-if="index==editIndex">
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                <span style="color: #FFF;">占</span>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                    class="el_item_option item_container_title">
                <!-- <i class="el-icon-plus el-icon-common" @click="wjaddquestionoption(question.optionList,question,0)">添加选项</i> -->
               <!-- <i class="el-icon-s-fold el-icon-common"
                   @click="wjaddquestionoption(question.optionList,question,2)">批量添加</i>
                <i class="el-icon-menu el-icon-common"
                   @click="wjaddquestionoption(question.optionList,question,1)">添加【其他】</i>-->
            </el-col>
        </el-row>
    </div>
    <!-- el-icon-time -->
</template>
<script>
    import FakeInput from './FakeInput.vue';
    export default {
        components:{
            FakeInput
        },
        data() {
            return {
                editOptionIndex: "0_0",
                options1: [],
                options2: [],
                value1: '',
                value2:'',
            }
        },
        props: {
			number: { type: Number, default: 0 },
            question: {},
            editIndex: {type:Number,default:0},
            isExistPage: {type:Boolean,default:false},
            index: {type:Number,default:0}
        },
        methods: {
            wjupdoption(item){
                this.$emit("wjupdoption",item);
            },
            updateQuestion(){
                this.$emit("wjupdquestionoption",this.question);
            },
            wjaddquestionoption(optionList, item, type = 1) {
                this.$emit("wjaddquestionoption", optionList, item, type);
            },
            showAdvance(e) {
                this.$emit("showAdvance",e);
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
            setEditOptionIndex(childIndex){
                this.editOptionIndex = this.editIndex+"_"+childIndex;
            },
            wjdelquestionoption(options,item,childindex){
                this.$emit("wjdelquestionoption",options,item,childindex)
            },
            questiondel(id){
                this.$emit("questiondel",id);
            },
            
        },
        created() {
           // console.log('questionTime',this.question)
        },
        mounted(){
            for(let i =0; i<24;i++) {
                if(i<10){
                    i = '0' + i
                }
                this.options1.push({value:i})
            }
            for(let i =0; i<60;i++) {
                if(i<10){
                    i = '0' + i
                }
                this.options2.push({value:i})
            }
            console.log(this.options1, this.options2)
        }
    }
</script>

<style scoped>
    .questiontime{
        margin-left:40px;
        margin-top:-10px;
        margin-bottom:10px;
    }
    .questiontime .fake-input{
        width: 160px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-top: 10px;
        text-indent: 20px;
        display: inline-block;
    }
    /deep/.questiontime .el-input__inner{
        border:1px solid #ccc !important;
    }
    .el-input--suffix .el-input__inner{
        border:1px solid #ccc;
    }
    .el-date-editor{
        width:600px;
        height:40px;
        border:1px solid #ccc;
        margin-bottom:20px;
    }
    /deep/.el-input__prefix{
        right:-560px !important;
    }
    /deep/.el-input__prefix i{
        color:#ccc;
    }
    /deep/.el-input__suffix{
        display:none !important;
    }
    .delete,.item {
        font-size: 22px !important;
        line-height: 40px !important;
        margin-right: 30px !important;
        text-align: right;
        float: right;
        cursor: pointer;
    }
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .askxh {
        line-height: 40px;
        text-align: right;
    }

    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }


    .item_container_title:hover {
    //border: 1px darkgrey dashed;

    }
</style>
